<template>
  <div id="app">
    <head-Back title="分享"></head-Back>
    <div class="page"></div>

    <div id="foot" class="foot" @click="toLogin">
      <button>立即免费开通使用</button>
    </div>
  </div>
</template>
<script>
import headBack from "../../../components/common/head-back";
import util from "@/utils/util";
import tips from "@/estoast";
import store from "@/store";
import wxapi from "../../../utils/wxapi";

import {
  commonShare,
  shareTitle,
  shareUrl,
  shareImg,
  shareDesc
} from "../../../utils/wxshare";

export default {
  name: "app",
  data() {
    return {
      msg: "注册协议",
      type: 1,
      shareid: null
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
    let url = window.location.href;
    var splitArray = url.split("#");
    var urlTem = splitArray[1];
    var paramstr = urlTem.split("?")[1];
    splitArray = paramstr.split("&");
    var param  = {};
    for (var i = 0, leni = splitArray.length; i < leni; i++) {
      var key = splitArray[i].split("=")[0];
      var value = splitArray[i].split("=")[1];
      if (!key) {
        continue;
      }
      param[key] = value;
    }

    var type = param["type"];
    var shareid = param["shareid"];
    console.log("type:" + type + "  shareid:" + shareid);
    this.type = type;
    this.shareid = shareid;
    // if (!util.isNum(this.shareid)) {
    //   tips.toast("地址不合法");
    //   this.$router.push("/index");
    // }

    this.shareWx();
  },
  methods: {
    toLogin: function() {
      this.$router.push({
        name: "login",
        params: { shareType: this.type, shareId: this.shareid }
      });
    },
    shareWx: function() {
      let opstion = {
        title: "一个懂事的聊天APP", // 分享标题
        link: window.location.href,
        imgUrl: "http://wap.haoyunba.com/static/img/logo-hyb.png", // 分享图标
        desc: "你的兄弟邀请您使用好运吧。只有好兄弟才会推荐给你用的特殊APP！"
      };
      console.log("分享的信息：" + JSON.stringify(opstion));
      commonShare(
        this,
        opstion.title,
        opstion.link,
        opstion.imgUrl,
        opstion.desc
      );
    }
  },
  components: {
    headBack
  }
};
</script>
<style  scoped>
.page {
  width: 750px;
  height: 3394px;
  background: url("../../../assets/img/share-back@2x.png");
  background-size: cover;
  white-space: nowrap;
  overflow: hidden;
}
.foot {
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  height: 136px;
  width: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 130, 223, 1) 0%,
    rgba(255, 75, 168, 1) 100%
  );
  padding: 28px 50px;
}
.foot {
  box-sizing: border-box;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 998;
}
.foot button {
  width: 652px;
  height: 80px;
  background: linear-gradient(
    90deg,
    rgba(114, 154, 255, 1) 0%,
    rgba(28, 97, 235, 1) 100%
  );
  border-radius: 10px;
  font-size: 32px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 80px;
  border: none;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/page/share/shareNews.vue